<template>
  <div class="orientation-switcher" id="orientationSwitcher">
    <div
        class="orientation-switcher__button orientation-switcher__button--portrait"
        :class="{'orientation-switcher__button--active': orientation === 'portrait' }"
        @click="emits('orientationSelected', 'portrait')"
    />
    <div
        class="orientation-switcher__button orientation-switcher__button--landscape"
        :class="{'orientation-switcher__button--active': orientation === 'landscape' }"
        @click="emits('orientationSelected', 'landscape')"
    />
    <div
        class="orientation-switcher__button orientation-switcher__button--square"
        :class="{'orientation-switcher__button--active': orientation === 'square' }"
        @click="emits('orientationSelected', 'square')"
    />
  </div>
</template>

<script setup lang="ts">
import { Orientation } from '@/types'

const props = defineProps<{
  orientation: Orientation
}>()

const emits = defineEmits<{
  (event: 'orientationSelected', orientation: Orientation): void
}>()

</script>

<style lang="scss">
.orientation-switcher {
  width: 128px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;

  &__button {
    display: inline-block;
    cursor: pointer;
    border: solid $grey-60 2px;

    &--portrait {
      margin-left: 21px;
      width: 14px;
      height: 24px;
    }

    &--landscape {
      // The Figma for some reason wants this
      margin-left: 18px;
      margin-right: 15px;
      width: 22px;
      height: 14px;
    }

    &--square {
      margin-right: 18px;
      width: 20px;
      height: 20px;
    }

    &--active {
      border: solid $white 2px;
    }
  }
}
</style>
